<template>
  <button class="vk-btn" type="button" @click="$emit('click', $event)">
    <svg-icon icon-name="vk" size="30" class="vk-btn__icon" /><slot />
  </button>
</template>

<script>
export default {
  name: "VkBtn"
};
</script>

<style lang="scss">
.vk-btn {
  font-size: 15px;
  color: #fff;
  background-color: #4680c2;
  height: 60px;
  border-radius: 4px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;

  &:hover {
    background-color: lighten(#4680c2, 5%);
  }

  &:active {
    background-color: darken(#4680c2, 5%);
  }

  &__icon {
    margin-right: 10px;
    flex-shrink: 0;
  }
}
</style>
